<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  //
})
</script>

<template>
   <div class="modal" id="modalPayAnimation" tabindex="-1" role="dialog" aria-labelledby="modalPayAnimation" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content pay-modal-animate__wrapp">
                <div class="modal-body">
                <div class="pay-modal-animate">
                    <div class="pay-modal-animate__heading">Відбувається процес формування чернетки</div>
                    <div class="pay-modal-animate__descr">Це займає від 3 до 20 секунд</div>
                    <div class="results_anime">
                        <div class="results_anime_circles">
                            <div class="waiting_animation">
                                <div class="background">
                                    <div class="loader loader-left"></div>
                                    <div class="loader loader-right"></div>
                                </div>
                            </div>
                        </div>
                        <div class="results_anime_percent">
                            <span class="results_anime_percent-text"></span>
                        </div>
                        <div class="results_anime_line">
                            <span class="results_anime_line-scale" :style="`width: 1%;`"></span>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
   </div>
</template>
